import React from 'react';
import { StyleSheet } from 'react-native';
import Modal from '@dbk/ui-modal';
import Text, { Large } from '@dbk/ui-text';
import Button from '@dbk/ui-buttons';
import {StatusError} from '@dbk/ui-icons';
import moment from 'moment';
import { ErrorIcon, SuccessIcon } from '../../components/common/icons';
import styles from './payment-confirmation.styles';
import { FormattedMessage } from '@dbk-legacy/format';
import { formatDateShortMonth, formatDateShortMonthWithoutDot } from '../../utils/date';

export default ({ status, messages, onDone, onNewPayment,execDate,isMultisigFlow=false,isInitiatorFlow=false }) => {

  const getTitle = () => {
    if(isMultisigFlow && isInitiatorFlow) {
      return messages['app.payments.multisig.cancelStatusModalTitleInitiator']  
    } else if (isMultisigFlow && !isInitiatorFlow) {
      return messages['app.payments.multisig.cancelStatusModalTitleApprover']
    }
    else {
      return status==='success' ? 
        messages['app.payment.pageTitle.confirm.payment'] : 
        messages['app.payment.pageTitle.payment.status']
    }
  }

  return (<Modal
    isActive
    size="large"
    className={"model-window-login"}
    hideCloseButton
    title={getTitle()}
    disableOutsideClick
    onClose={() => {}}
    header={
      getTitle()}
    content={
      <div className="modal-payment-status">
        {status==='success' ?
        <div className="modal-content">
          <div className="payment-status-message">
            <SuccessIcon width={30} height={30} />
            <Text size={"large"} tabIndex={0}>
              {messages['app.payments.confirmation.success']}
            </Text>
          </div>
          <div tabIndex={0}>
            {isMultisigFlow && isInitiatorFlow ?
            // success message for multisig initiator flow
              <>
                <div>
                  <Large role="alert" tabIndex={0} aria-label={messages['app.payments.multisig.successModalHeaderForInitiator1']}>
                    {messages['app.payments.multisig.successModalHeaderForInitiator1']}
                  </Large>
                </div>
                <div>
                  <Large role="alert" tabIndex={0} aria-label={messages['app.payments.multisig.successModalHeaderForInitiator2']}>
                    {messages['app.payments.multisig.successModalHeaderForInitiator2']}
                  </Large>
                </div>
              </>
            :
            //success message for standard flow and multisig approval flow
            <FormattedMessage
              id={'app.payments.confirmation.successMessage'}
              values={{ executionDate: formatDateShortMonthWithoutDot(execDate) }} /> }
          </div>
        </div> :
          status==='reject' ?
        <div className="modal-content">
          <div className="payment-status-message">
            <StatusError width={30} height={30} />
            <Large role="alert" tabIndex={0} aria-label={messages['app.payments.confirmation.success']}>
              {messages['app.payments.confirmation.success']}
            </Large>
          </div>
          <div>
            <Large role="alert" tabIndex={0} aria-label={messages['app.payments.cancellation.errorMessage']}>{messages['app.payments.cancellation.errorMessage']}</Large>
          </div>
        </div>:
        <div className="modal-content">
          <div className="payment-status-message">
           <ErrorIcon width={30} height={30} />
           <Large role="alert" tabIndex={0} aria-label= {messages['app.payments.confirmation.dataIntegrityError']}>
           {messages['app.payments.confirmation.dataIntegrityError']}
           </Large>
        </div>
        <div>
          <Large role="alert" tabIndex={0} aria-label={messages["app.payments.dataIntegrity.errorMessage"]}>{messages["app.payments.dataIntegrity.errorMessage"]}</Large>
       </div>
     </div>}
     
     <div className="modal-footer">
       <div style={StyleSheet.flatten(styles.paymentBtnTerminate)}>
     {status==='terminate'?
     <div >
     <Button
       fullWidth
       size={"large"}
       onPress={onDone} >
       {messages['app.forgotPassword.button.ok']}
     </Button>
     </div>
     :
     <div style={StyleSheet.flatten(styles.paymentBtnBlock)}>
     <div  style={StyleSheet.flatten(styles.paymentNewRMrgn)}>
     <Button
       tertiary
       size={"large"}
       fullWidth
       onPress={onNewPayment} >
       {messages['app.payments.new.payment']}
     </Button>
   </div>
     <div >
     <Button
      className="btnPaymentDone"
       size={"large"}
       fullWidth
       onPress={onDone} >
       {messages['app.payments.payment.done']}
     </Button>
   </div>  
   </div>     
   }
    </div>
    </div>
      </div>
    }
  />
)
}